<template>
  <section class="login-wrapper">
    <section class="login">
      <header>
        <h1>Hey! Do we know you?</h1>
      </header>
      <form @submit.prevent="submit">
        <div>
          <ab-text-field v-model="email" :label="'Email'" />
        </div>
        <div>
          <ab-text-field v-model="password" :label="'Password'" type="password" />
        </div>
        <div v-if="isRequestFailed" class="error">
          Authentication failed. Check your email/password and try again.
        </div>
        <div class="form-row submit">
          <ab-button class="secondary" :disabled="!isValid || isRequestPending">Sign In</ab-button>
        </div>
        <div class="form-row submit">
          - OR -
        </div>
        <div class="form-row submit">
          <ab-button class="secondary google" @click.stop.prevent="google">Sign In with Google</ab-button>
          <ab-button class="secondary apple" @click.stop.prevent="apple">Sign In with Apple</ab-button>
        </div>
      </form>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './common/Button';
import TextField from './common/TextField';
export default {
  components: {
    'ab-button': Button,
    'ab-text-field': TextField
  },
  data() {
    return {
      email: '',
      password: ''
    };
  },
  computed: {
    ...mapState({
      isRequestPending: s => s.identity.isRequestPending,
      isRequestFailed: s => s.identity.isRequestFailed
    }),
    isValid() {
      return this.email.length && this.password.length;
    }
  },
  methods: {
    async submit() {
      if (!this.isValid) {
        return;
      }

      await this.$store.dispatch('identity/login', { email: this.email, password: this.password });
    },
    async google() {
      const response = await fetch(`https://auth.yasnah.com/google?redirect_uri=${document.location.origin}/google.html`);
      const url = await response.text();
      window.location.href = url;
    },
    async apple() {
      const params = [
        `redirect_uri=https://auth.yasnah.com/apple/callback`,
        `callback_uri=${document.location.origin}/apple.html`
      ];
      const response = await fetch(`https://auth.yasnah.com/apple?${params.join('&')}`);
      const url = await response.text();
      window.location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
.login-wrapper {
  min-height: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: max-content 1fr;
  background-image: url('/newsletterbg.png');
  background-attachment: scroll;
  background-position: bottom;
  background-size: cover;
  background-repeat: no-repeat;

  .login {
    padding: 2rem;
  }

  header {
    width: 100%;
    text-align: center;
  }

  h1 {
    text-align: center;
  }
  form {
    max-width: 480px;
    margin: auto;
    // padding: 2rem;

    > * {
      &:not(:last-child) {
        margin-bottom: 1.5rem;
      }
      &.submit {
        display: flex;
        justify-content: center;
        @media only screen and (max-width: 768px) {
          flex-wrap: wrap;
          button {
            width: 100%;
            margin-right: 0 !important;

            &:not(:last-child) {
              margin-bottom: 0.5rem;
            }
          }
        }
      }
    }

    .error {
      font-size: 0.8rem;
      font-weight: 700;
      color: var(--theme-error);
      text-align: center;
    }

    button {
      &.google {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 14px;
        text-transform: none;

        &:before {
          content: '';
          background: url('~@/assets/google.svg');
          width: 18px;
          height: 18px;
          margin-right: 24px;
        }
      }

      &.apple {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 14px;
        text-transform: none;

        &:before {
          content: '';
          background: url('~@/assets/apple.svg');
          background-size: contain;
          width: 18px;
          height: 18px;
          margin-right: 24px;
        }
      }

      &:not(:last-child) {
        margin-right: 2rem;
      }
    }
  }
}
</style>
